import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { PIC_REGEXP_SOFT } from '../../../constants'

class PICField extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {}
    this.onChange = this.onChange.bind(this)
    this.input = React.createRef()
  }
  onChange () {
    let { value } = this.input.current
    value = value.toUpperCase()
    if (PIC_REGEXP_SOFT.test(value) || !value) {
      this.props.onChange(value)
    }
  }
  render () {
    const { invalid, isRequired, noTab, title, value } = this.props
    return (
      <div className='form-row'>
        <div className='row-title'>
          <p
            className={`row-text ${invalid ? 'row-text-invalid' : ''}`}>
            {title}{isRequired ? <span className='asterisk'>*</span> : ''}:
          </p>
        </div>
        <div className='row-content'>
          <input
            ref={this.input}
            className='input'
            type='text'
            value={value}
            onChange={this.onChange}
            autoCapitalize='off'
            {...noTab ? { tabIndex: -1 } : {}}
          />
        </div>
      </div>
    )
  }
}

PICField.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  invalid: PropTypes.bool.isRequired,
  isRequired: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  noTab: PropTypes.bool.isRequired
}

PICField.defaultProps = {
  invalid: false,
  noTab: false
}

export default PICField
